import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dot"
}
const _hoisted_2 = {
  key: 0,
  class: "deactivated-text"
}

import { Alarm } from '@/server/MakeSenseApp-backend'



export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmDescriptionCell',
  props: {
  alarm: {
    required: true,
    type: Alarm
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ms-description-cell NKT-P1", { deactivated: __props.alarm.active === false, attention: __props.alarm.visited === false }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["description", { visited: __props.alarm.visited === true, deactivated: !__props.alarm.active }])
    }, [
      (__props.alarm.visited === false)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.alarm.description), 1)
    ], 2),
    (!__props.alarm.active)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Deactivated "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})